var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseTagIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close Icon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99987 8.93337L4.7332 12.2C4.61098 12.3223 4.45543 12.3834 4.26654 12.3834C4.07765 12.3834 3.92209 12.3223 3.79987 12.2C3.67765 12.0778 3.61654 11.9223 3.61654 11.7334C3.61654 11.5445 3.67765 11.3889 3.79987 11.2667L7.06654 8.00003L3.79987 4.73337C3.67765 4.61114 3.61654 4.45559 3.61654 4.2667C3.61654 4.07781 3.67765 3.92225 3.79987 3.80003C3.92209 3.67781 4.07765 3.6167 4.26654 3.6167C4.45543 3.6167 4.61098 3.67781 4.7332 3.80003L7.99987 7.0667L11.2665 3.80003C11.3888 3.67781 11.5443 3.6167 11.7332 3.6167C11.9221 3.6167 12.0776 3.67781 12.1999 3.80003C12.3221 3.92225 12.3832 4.07781 12.3832 4.2667C12.3832 4.45559 12.3221 4.61114 12.1999 4.73337L8.9332 8.00003L12.1999 11.2667C12.3221 11.3889 12.3832 11.5445 12.3832 11.7334C12.3832 11.9223 12.3221 12.0778 12.1999 12.2C12.0776 12.3223 11.9221 12.3834 11.7332 12.3834C11.5443 12.3834 11.3888 12.3223 11.2665 12.2L7.99987 8.93337Z",
    fill: "var(--fill-0, #ACACB0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTagIcon);
export default __webpack_public_path__ + "static/media/close-tag-icon.f1d6e63a2b8dbe89e5355636c70a037c.svg";
export { ForwardRef as ReactComponent };